var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zyro-label",style:(_vm.computedStyles)},[_c('label',_vm._g(_vm._b({staticClass:"zyro-label__label",class:{
			'z-body-small': _vm.theme === 'primary',
			'z-subheading-small': _vm.theme === 'secondary',
			'z-body-small--strong': _vm.bold
		}},'label',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2),(_vm.infoText)?_c('ZyroInfo',{attrs:{"info-text":_vm.infoText}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }